import api from './api';
import ErrorHandler from './errorHandler';

/**
 * Category API Service
 */
class CategoryService {
    /**
     * Get all categories
     * @param {object} params - Query parameters (search, sortBy, sortOrder)
     * @returns {Promise<object>} Response with categories list
     */
    async getAllCategories(params = {}) {
        try {
            const response = await api.get('/api/categories', { params });
            return response; // Return full axios response like tagService
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /**
     * Get category by ID
     * @param {number} id - Category ID
     * @returns {Promise<object>} Response with category details
     */
    async getCategoryById(id) {
        try {
            const response = await api.get(`/api/categories/${id}`);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /**
     * Get category statistics
     * @returns {Promise<object>} Response with category statistics
     */
    async getCategoryStats() {
        try {
            const response = await api.get('/api/categories/stats');
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /**
     * Create new category
     * @param {object} categoryData - Category data (name, slug, description)
     * @returns {Promise<object>} Response with created category
     */
    async createCategory(categoryData) {
        try {
            const response = await api.post('/api/categories', categoryData);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /**
     * Update category
     * @param {number} id - Category ID
     * @param {object} categoryData - Updated category data
     * @returns {Promise<object>} Response with updated category
     */
    async updateCategory(id, categoryData) {
        try {
            const response = await api.put(`/api/categories/${id}`, categoryData);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /**
     * Delete category
     * @param {number} id - Category ID
     * @returns {Promise<object>} Response with deletion result
     */
    async deleteCategory(id) {
        try {
            const response = await api.delete(`/api/categories/${id}`);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

}

export default new CategoryService();
